function calculateBankWirePrice(price: number) {
  const discountWire = 2
  return Math.round(price - discountWire * price * 0.01)
}

export default calculateBankWirePrice
